import { ViewMode } from '../../../cross-team-shared/state/abstract-sensor-content-state';
import { ImageAnnotationOutput } from '../../../team-apis/otterdam/outputs/image-annotation-output';
import {
  AbstractSensorContentState2D,
  PartialRawMask,
} from '../../shared/state/abstract-sensor-content-state-2d';
import { RGB, RGBA } from '../utils/color-utils';
import { TagOptionState } from './tag-option-state';

export const WHITE_CODE = 254;
export const BLACK_CODE = 255;

export const TAG_OPTION_ZERO = {
  code: 0,
  rgb: [255, 255, 255] as RGB,
  label: 'no label',
};

export class ImageContentState extends AbstractSensorContentState2D {
  override output!: ImageAnnotationOutput;
  tagOptions!: TagOptionState[];
  selectedTagOptionCode!: number;
  rawMask?: Uint8Array;
  imageOverlayData?: Uint8ClampedArray;
  highlightedCode?: number;
  partialRawMask?: PartialRawMask;
  lockMask = false;
  hasFocus = false;
}

// eslint-disable-next-line complexity -- if you need to modify this code, fix this first
export function getRgba(
  tagOption: TagOptionState | undefined,
  highlightedCode: number | undefined,
  viewMode: ViewMode,
  layerOpacity: number,
): RGBA {
  if (!tagOption) {
    return [0, 0, 0, 0];
  }

  const rgba = [...tagOption.rgb, layerOpacity / 100] as RGBA;
  if (viewMode === 'layers' || tagOption.code === highlightedCode) {
    rgba[3] = 1;
  } else if (viewMode === 'none' || !tagOption.code) {
    rgba[3] = 0;
  }
  return rgba;
}
